import React, { useContext } from 'react';
import { INPUT_TYPES } from 'utils/CommonConstants';
import TextInput from 'sub_components/Common/BloxTextInput';
import styled from 'styled-components';
import { ServiceRequestContext } from 'context/ServiceRequestContext';
const CDN_URL = process.env.REACT_APP_CDN_URL;

const LowDefault = `${CDN_URL}common/low-priority-default-lg.svg`;
const LowSelected = `${CDN_URL}common/low-priority-selected-lg.svg`;
const MedDefault = `${CDN_URL}common/medium-priority-default-lg.svg`;
const MedSelected = `${CDN_URL}common/medium-priority-selected-lg.svg`;
const HighDefault = `${CDN_URL}common/high-priority-default-lg.svg`;
const HighSelected = `${CDN_URL}common/high-priority-selected-lg.svg`;

const RackDetailsScreenStyle = styled.div`
	.blox-text-input {
		width: 100%;
		margin-bottom: 8px;
	}
	.priority-selection-wrapper {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 25px;
	}
	.priority-selection {
		width: 80px;
		height: 88px;
		display: flex;
		flex-basis: 50%;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		cursor: pointer;
		.title {
			margin-top: 16px;
			color: ${props => props.theme.$Cool_Gray_Dark_3};
		}
		img {
			width: 40px;
			height: 32px;
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.blox-text-input {
			margin-bottom: 20px;
		}
		.priority-selection-wrapper {
			width: 100%;

			.priority-selection {
				width: 96px;
				height: 112px;

				img {
					width: 58px;
					height: 54px;
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.blox-text-input {
			margin-bottom: 50px;
		}
		.priority-selection-wrapper {
			.priority-selection {
				width: 176px;
				height: 208px;

				img {
					width: 94px;
					height: 94px;
				}
			}
		}
	}
`;

function onMouseEnter(id) {
	const icon = document.getElementById(id);

	if (id === 'LOW') {
		icon.src = LowSelected;
	} else if (id === 'MED') {
		icon.src = MedSelected;
	} else if (id === 'HIGH') {
		icon.src = HighSelected;
	} else {
		icon.src = MedSelected;
	}
}

function onMouseLeave(id, typeIcon) {
	const icon = document.getElementById(id);
	icon.src = typeIcon;
}

export const RackDetailsScreen = () => {
	const { inputs, change } = useContext(ServiceRequestContext);
	const ila = inputs?.type === 'ila' ? true : false;

	function onPriorityChange(priority) {
		change({ target: { name: 'priority', value: priority } });
	}
	const selected = inputs?.priority;
	const lowIcon = selected === 'low' ? LowSelected : LowDefault;
	const medIcon = selected === 'medium' ? MedSelected : MedDefault;
	const highIcon = selected === 'high' ? HighSelected : HighDefault;

	return (
		<RackDetailsScreenStyle>
			{!ila && (
				<TextInput
					placeholder=''
					label='Pod Number'
					name='podNumber'
					value={inputs.podNumber}
					onChange={change}
					hideCheckmark
					validations={[
						{
							message: "That's not a valid Pod Number",
							pattern: /^[A-Za-z0-9-]*$/,
						},
					]}
					maxlength={60}
					active={true}
					type={INPUT_TYPES.INPUT}
					cypressId='ga-pod'
				/>
			)}
			{!ila && (
				<TextInput
					placeholder=''
					type={INPUT_TYPES.INPUT}
					label='Cabinet ID'
					name='cabNumber'
					hideCheckmark
					value={inputs.cabNumber}
					onChange={change}
					validations={[{ message: "That's not a valid Cabinet ID", pattern: /^[A-Za-z0-9-]*$/ }]}
					active={true}
					maxlength={60}
					cypressId='service-request-title'
				/>
			)}
			{ila && (
				<div className={'priority-selection-wrapper'}>
					<div
						className='priority-selection'
						onClick={() => onPriorityChange('low')}
						onMouseEnter={() => onMouseEnter('LOW')}
						onMouseLeave={() => onMouseLeave('LOW', lowIcon)}
						data-cy='priority-low'
						id='priority-low'
					>
						<img src={lowIcon} id='LOW' />
						<div className='title heading76'>Low</div>
					</div>

					<div
						className={`priority-selection`}
						onClick={() => onPriorityChange('medium')}
						onMouseEnter={() => onMouseEnter('MED')}
						onMouseLeave={() => onMouseLeave('MED', medIcon)}
						data-cy='priority-med'
						id='priority-med'
					>
						<img src={medIcon} id='MED' />
						<div className='title heading76'>Medium</div>
					</div>

					<div
						className={`priority-selection  `}
						onClick={() => onPriorityChange('high')}
						onMouseEnter={() => onMouseEnter('HIGH')}
						onMouseLeave={() => onMouseLeave('HIGH', highIcon)}
						data-cy='priority-high'
						id='priority-high'
					>
						<img src={highIcon} id='HIGH' />
						<div className='title heading76'>High</div>
					</div>
				</div>
			)}
		</RackDetailsScreenStyle>
	);
};
